// test1075
(1075 && 0);
